export const config = {
  API_URL: process.env.NX_PLACEME_API_URL, // FOR TILES
  GEOCODE_KEY: process.env.NX_GOOGLE_KEY_GEOCODE,
}
